import { ActionTypes } from './action-types.enum';

// eslint-disable-next-line import/prefer-default-export
export const showError = (show, errorMessage) => ({
  type: ActionTypes.SHOW_ERROR,
  payload: {
    show,
    errorMessage: errorMessage || '',
  }
});
